import React from 'react';
import { Flex } from '@chakra-ui/react';
import WorkFlowBuckets from '../WorkFlowBuckets';
import { ICOCConfig } from '@publishing-engine/domain/models';

interface WorkflowBucketsTabProps {
  journalId: string;
  journalName: string;
  cocConfig?: ICOCConfig[];
}

const WorkFlowBucketsTab: React.FC<WorkflowBucketsTabProps> = ({
  journalId,
  cocConfig
}) => {
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <WorkFlowBuckets journalId={journalId} cocConfig={cocConfig} />
    </Flex>
  );
};

export default React.memo(WorkFlowBucketsTab);
